module.exports = __webpack_public_path__ + "static/Truck18-95c44cf9257c87ef43653b337e352445.png";